import Home from "./Home.vue";
import { createApp } from "vue";
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';

const grayPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{gray.50}',
            100: '{gray.100}',
            200: '{gray.200}',
            300: '{gray.300}',
            400: '{gray.400}',
            500: '{gray.500}',
            600: '{gray.600}',
            700: '{gray.700}',
            800: '{gray.800}',
            900: '{gray.900}',
            950: '{gray.950}'
        }
    }
});

class EinvoiceRequest {
    constructor(wrapper, customer_session_id) {
        this.$wrapper = $(wrapper);
        this.customer_session_id = customer_session_id;
        this.make_body();
    }
    make_body() {
        if (this.$wrapper.get(0).__vue_app__) {
            this.$wrapper.get(0).__vue_app__.unmount();
        }
        const app = createApp(Home, {
            customer_session_id: this.customer_session_id
        });
        app.use(PrimeVue, {
            theme: {
                preset: grayPreset,
                options: {
                    prefix: "pv",
                    darkModeSelector: 'none',
                    cssLayer: false
                }
            }
        });
        this.$component = app.mount(this.$wrapper.get(0));
    }
};

frappe.provide("myinvois.app");
myinvois.app.einvoice_request = EinvoiceRequest;
export default EinvoiceRequest;